<div class="order-container">
    <div class="header-container">
        <div class="header-section">
            <div class="order-title flex justify-between">
                <div class="flex">
                    <div class="cursor-pointer" (click)="back.emit()"><i class="pi pi-arrow-left"> </i></div>  
                    @if(order()){<div>{{order()?.code}} - {{order()?.shortDescription}}</div>}
                    @else{<div>Nuova commessa</div>}
                </div>
                <div>
                    @if(order()?.orderId){
                        <p-button (click)="onDelete()" icon="pi pi-trash" severity="danger" label="Elimina" ></p-button>
                    }
                </div>
            </div>
            @if(order()){<div class="order-subtitle">{{order()?.description ?? '-'}}</div>}
            @else{<div class="order-subtitle">Inserisci i dati della commessa</div>}

        </div>

        <div class="tab-bar-container">
            <div class="tab-bar">
                <div class="tab-item" [class.active]="orderPage() === 0" (click)="switchOrderPage(0)">Commessa</div>
                 @if(order()&& order()?.stateId && order()?.stateId! > 1){<div class="tab-item" [class.active]="orderPage() === 1" (click)="switchOrderPage(1)">Posizioni</div>}
            </div>
        </div>

        @if(orderPage() === 1) {
            <div class="tab-bar-container">
                @if(order()?.positions) {
                    <div class="tab-bar">
                        @for (item of order()?.positions; track item.positionId) {
                            <div class="tab-item" 
                                [class.active]="selectedPositionId() === item.positionId"
                                (click)="switchPosition(item.positionId)">
                                {{item.code}} - {{item.shortDescription}}
                            </div>
                        }
                    </div>
                }
            </div>

            @if(selectedPosition()) {
                <div class="tab-bar-container">
                    <div class="tab-bar">
                        <div class="tab-item" [class.active]="positionStatePage() === 0" (click)="switchPositionStatePage(0)">Informazioni generali</div>
                        @if(selectedPosition()?.preventive){<div class="tab-item" [class.active]="positionStatePage() === 1" (click)="switchPositionStatePage(1)">Preventivo</div>}
                        @if(selectedPosition()?.project){<div class="tab-item" [class.active]="positionStatePage() === 2" (click)="switchPositionStatePage(2)">Progettazione</div>}
                        @if(selectedPosition()?.production){<div class="tab-item" [class.active]="positionStatePage() === 3" (click)="switchPositionStatePage(3)">Produzione</div>}
                        @if(selectedPosition()?.shipping){<div class="tab-item" [class.active]="positionStatePage() === 4" (click)="switchPositionStatePage(4)">Spedizione</div>}
                    </div>
                </div>
            }
        }
    </div>

    <div class="viewport">
        <div class="strip" [style.transform]="'translateX(' + (orderPage() * -100) + '%)'">
            
            <div class="slide">
                <div class="content-area">
                    <spike-workflow-stepper [stateId]="order() && order()!.stateId ? order()!.stateId! :1" [workflow]="ordineWorkflow" >
                        <spike-workflow-actions [order]="order()" (updated)="refresh()"/>
                    </spike-workflow-stepper>
                    <spike-order-general-toggle-panel [data]="order()!" (onSave)="save($event)" (formViewChange)="updateFormViewSet(0, $event)"/>
                </div>
            </div>

            <div class="slide">
                <div class="content-area">
                    @if(selectedPosition()) {
                        
                        <div class="viewport">
                            <div class="strip" [style.transform]="'translateX(' + (positionStatePage() * -100) + '%)'">
                                
                                <div class="slide">
                                    @if(positionStatePage() === 0){
                                    <spike-workflow-stepper [stateId]="selectedPosition()!.stateId!" [workflow]="positionWorkflow.list!" ></spike-workflow-stepper>
                                    <spike-position-general-toggle-panel [data]="selectedPosition()!" (onSave)="refresh()" (formViewChange)="updateFormViewSet(1, $event)"></spike-position-general-toggle-panel>
                                    }
                                </div>

                                <div class="slide">
                                    @if(positionStatePage() === 1 && selectedPosition()!.preventive){
                                    <spike-workflow-stepper [stateId]="selectedPosition()!.preventive!.stateId!" [workflow]="preventiveWorkflow.list!">
                                        <spike-workflow-actions [position]="selectedPosition()" [state]="2" [substate]="selectedPosition()!.preventive!.stateId!" (updated)="refresh()" [disabled]="isEditView()"/>
                                    </spike-workflow-stepper>
                                    <spike-working-phase-general-toggle-panel [data]="selectedPosition()!.preventive!" (onSave)="refresh()" (formViewChange)="updateFormViewSet(2, $event)"/>
                                    <spike-working-phase-toggle-panel [data]="selectedPosition()!.preventive!" [workflowState]="preventiveWorkflow" (onSave)="refresh()" (formViewChange)="updateFormViewSet(3, $event)"/>
                                    }
                                </div>

                                <div class="slide">
                                    @if(positionStatePage() === 2 && selectedPosition()!.project){
                                    <spike-workflow-stepper [stateId]="selectedPosition()!.project!.stateId!" [workflow]="projectWorkflow.list!">
                                        <spike-workflow-actions [position]="selectedPosition()" [state]="3" [substate]="selectedPosition()!.project!.stateId!" (updated)="refresh()" [disabled]="isEditView()"/>
                                    </spike-workflow-stepper>
                                    <spike-working-phase-general-toggle-panel [data]="selectedPosition()!.project!" (onSave)="refresh()" (formViewChange)="updateFormViewSet(4, $event)"></spike-working-phase-general-toggle-panel>
                                    <spike-working-phase-toggle-panel [data]="selectedPosition()!.project!" [workflowState]="projectWorkflow" (onSave)="refresh()" (formViewChange)="updateFormViewSet(5, $event)"/>
                                    }
                                </div>

                                <div class="slide">
                                @if(positionStatePage() === 3   && selectedPosition()!.production){
                                    <spike-workflow-stepper [stateId]="selectedPosition()!.production!.stateId!" [workflow]="productionWorkflow.list!">
                                        <spike-workflow-actions [position]="selectedPosition()" [state]="4" [substate]="selectedPosition()!.production!.stateId!" (updated)="refresh()" [disabled]="isEditView()">
                                            <p-button severity="secondary" outlined="true" label="Scheda" icon="pi pi-print" (click)="show()"/> 
                                        </spike-workflow-actions>
                                    </spike-workflow-stepper>

                                    <spike-working-phase-general-toggle-panel [data]="selectedPosition()!.production!" (onSave)="refresh()" (formViewChange)="updateFormViewSet(6, $event)"></spike-working-phase-general-toggle-panel>
                                    <spike-working-phase-toggle-panel [data]="selectedPosition()!.production!" [workflowState]="productionWorkflow" (onSave)="refresh()" (formViewChange)="updateFormViewSet(7, $event)"/>
                                }
                                </div>
                                <div class="slide">
                                @if(positionStatePage() === 4  && selectedPosition()!.shipping){
                                    <spike-workflow-stepper [stateId]="selectedPosition()!.shipping!.stateId!" [workflow]="shippingWorkflow.list!">
                                        <spike-workflow-actions [position]="selectedPosition()" [state]="5" [substate]="selectedPosition()!.shipping!.stateId!" (updated)="refresh()" [disabled]="isEditView()"/>
                                    </spike-workflow-stepper>
                                    <spike-shipping-toggle-panel [data]="selectedPosition()!.shipping!" (onSave)="refresh()" (formViewChange)="updateFormViewSet(8, $event)"></spike-shipping-toggle-panel>
                                }
                                </div>
                            </div>
                        </div>

                    } @else {
                        <div class="p-4 text-center">
                            <spike-no-result icon="pi pi-info-circle" message="Seleziona una posizione per visualizzare i dettagli."></spike-no-result>
                        </div>
                    }
                </div>
            </div>

        </div>
    </div>
</div>
